import { render, staticRenderFns } from "./DuplicatePortCall.vue?vue&type=template&id=56279f36&scoped=true&"
import script from "./DuplicatePortCall.vue?vue&type=script&lang=js&"
export * from "./DuplicatePortCall.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePortCall.vue?vue&type=style&index=0&id=56279f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56279f36",
  null
  
)

export default component.exports